import React, { Component } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import EquipmentApi from "../../api/EquipmentApi";
import AuthService from "../../session/AuthService";
import EnlargeImage from "../../customFunctions/EnlargeImage";
import { API_URL } from "../../config/app-config";

class CreateEquipment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formValues: {},
      colorChange: false,
      isModalOpen : false 
    };
  }


//   getBaseUrl = () => {
//     const hostname = window.location.hostname;

//     if (hostname === "localhost") {
//         return "http://localhost:8081";
//     } else if (hostname === "farmconnect.betalearnings.com") {
//         return "http://farmconnect.betalearnings.com/FarmConnect";
//     } else if (hostname === "35.182.98.99") {
//         return "http://35.182.98.99/FarmConnect";
//     } else {
//         // Add a default case or return an error message if none of the conditions match
//         return "http://defaultBaseUrl";
//     }
// };


  componentDidMount = () => {
    console.log("option in create data", this.props);
    if (
      this.props.editValue &&
      Object.keys(this.props.editValue).length > 0 &&
      this.props.option === "edit"
    ) {
      this.setState({
        formValues: this.props.editValue,
        colorChange: true,
      });
    }
  };

  render() {
    console.log("this.state.formvalues" , this.state.formValues.equipmentImage)
    const { formValues, colorChange } = this.state;
    return (
      <>
        <Modal
          show={this.props.show}
          onHide={this.props.handleClose}
          backdrop="static"
        >
          <Modal.Header closeButton>
            <h5 style={{ fontWeight: "bolder" }}>
              {this.props.option === "edit"
                ? "Edit Equipment"
                : "Add Equipment"}
            </h5>
          </Modal.Header>
          <Modal.Body>
            <Form.Group className="mb-2" controlId="exampleForm.ControlInput1">
              <Form.Label> Name</Form.Label>
              <Form.Control
                type="text"
                // placeholder="Name"
                autoFocus
                className="small-input"
                name="equipmentName"
                onChange={this.OnHandleChange}
                value={formValues.equipmentName}
                readOnly={AuthService.getUserTypeAdmin() === "3"}
              />
            </Form.Group>
            <Form.Group className="mb-2" controlId="exampleForm.ControlInput1">
              <Form.Label>Model</Form.Label>
              <Form.Control
                type="text"
                // placeholder="Model"
                autoFocus
                className="small-input"
                name="equipmentModel"
                onChange={this.OnHandleChange}
                value={formValues.equipmentModel}
                readOnly={AuthService.getUserTypeAdmin() === "3"}
              />
            </Form.Group>

            <div class="form-group" style={{ marginBottom: "10px" }}>
              <label
                for="exampleFormControlTextarea1"
                style={{ fontSize: "14px", fontWeight: 500 }}
              >
                Description
              </label>
              <textarea
                class="form-control"
                id="exampleFormControlTextarea1"
                name="equipmentDescription"
                onChange={this.OnHandleChange}
                value={formValues.equipmentDescription}
                style={{ backgroundColor: "#F3F4F1", borderColor: "#F3F4F1" }}
                readOnly={AuthService.getUserTypeAdmin() === "3"}
              ></textarea>
            </div>

            <div className="Border-line"></div>

            <div className="row">
              <div className="col">
                <Form.Group
                  className="mb-2"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Year</Form.Label>
                  <Form.Control
                    type="number"
                    // placeholder="Years"
                    autoFocus
                    className="small-input"
                    name="equipmentYears"
                    onChange={this.OnHandleChange}
                    value={formValues.equipmentYears}
                    readOnly={AuthService.getUserTypeAdmin() === "3"}
                    onInput={(e) => {
                      // Allow only numbers
                      e.target.value = e.target.value.replace(/[^0-9]/g, '').slice(0, 4);
                  }}
                  onPaste={(e) => {
                      // Handle paste events
                      const pastedText = e.clipboardData.getData('text/plain');
                      const pastedNumbers = pastedText.replace(/[^0-9]/g, '').slice(0, 4);
                      e.preventDefault();
                      document.execCommand('insertText', false, pastedNumbers);
                  }}
                  
                  />
                </Form.Group>
              </div>
              <div className="col">
                <Form.Group
                  className="mb-2"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>S/N</Form.Label>
                  <Form.Control
                    type="text"
                    // placeholder="S/N"
                    autoFocus
                    className="small-input"
                    name="equipmentSN"
                    onChange={this.OnHandleChange}
                    value={formValues.equipmentSN}
                    readOnly={AuthService.getUserTypeAdmin() === "3"}
                  />
                </Form.Group>
              </div>
            </div>

            <Form.Group className="mb-2" controlId="exampleForm.ControlInput1">
              <Form.Label>Year Acquired</Form.Label>
              <Form.Control
                type="text"
                // placeholder="Year Acquired"
                autoFocus
                className="small-input"
                name="year_acquired"
                onChange={this.OnHandleChange}
                value={formValues.year_acquired}
                readOnly={AuthService.getUserTypeAdmin() === "3"}
              />
            </Form.Group>
            <div class="form-group" style={{ marginBottom: "10px" }}>
              <label
                for="exampleFormControlTextarea1"
                style={{ fontSize: "14px", fontWeight: 500 }}
              >
               Oil type and capacities
              </label>
              <textarea
                class="form-control"
                id="exampleFormControlTextarea1"
                rows="3"
                name="oilType"
                onChange={this.OnHandleChange}
                value={formValues.oilType}
                style={{ backgroundColor: "#F3F4F1", borderColor: "#F3F4F1" }}
                readOnly={AuthService.getUserTypeAdmin() === "3"}
              ></textarea>
            </div>
            <div class="form-group" style={{ marginBottom: "10px" }}>
              <label
                for="exampleFormControlTextarea1"
                style={{ fontSize: "14px", fontWeight: 500 }}
              >
                Filter and Parts Numbers
              </label>
              <textarea
                class="form-control"
                id="exampleFormControlTextarea1"
                rows="3"
                name="filterParts"
                onChange={this.OnHandleChange}
                value={formValues.filterParts}
                style={{ backgroundColor: "#F3F4F1", borderColor: "#F3F4F1" }}
                readOnly={AuthService.getUserTypeAdmin() === "3"}
              ></textarea>
            </div>
            <div class="form-group" style={{ marginBottom: "10px" }}>
              <label
                for="exampleFormControlTextarea1"
                style={{ fontSize: "14px", fontWeight: 500 }}
              >
                Notes
              </label>
              <textarea
                class="form-control"
                id="exampleFormControlTextarea1"
                rows="3"
                name="notes"
                onChange={this.OnHandleChange}
                value={formValues.notes}
                style={{ backgroundColor: "#F3F4F1", borderColor: "#F3F4F1" }}
                readOnly={AuthService.getUserTypeAdmin() === "3"}
              ></textarea>
            </div>

               
            <Form.Group className="mb-2" controlId="exampleForm.ControlInput1">
              <Form.Label>Time Service Interval with Activity</Form.Label>
              <select
                className="form-select form-select-sm"
                aria-label="form-select-sm example"
                id="form-select-sm-employee"
                type="text"
                name="equipmentTimeService"
                onChange={this.OnHandleChange}
                value={formValues.equipmentTimeService}
                style={{ color: colorChange ? "black" : "#747c84" }}
                disabled={AuthService.getUserTypeAdmin() === "3"}
              >
                <option selected>Select</option>
                <option value="semi">Semi</option>
                <option value="quarterly">Quarterly</option>
                <option value="monthly">Monthly</option>
                <option value="yearly">Yearly</option>
              </select>
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicNo">
              <Form.Label>Upload File</Form.Label>
              <br />
              <div className="custom-file">
              
             
      {this.state.formValues.resourceImage ? (
    <label htmlFor="customFile" className="file-label">
      {this.state.formValues.resourceImage.name}
    </label>
  ) : (
    <label htmlFor="customFile" className="file-label">
      {this.props.option === "edit" && this.props.editValue.orginalImageName !== null
        ? this.props.editValue.orginalImageName 
        : "Click to Upload File"}
    </label>
  )}
                  <input
                    type="file"
                    id="customFile"
                    onChange={this.handlefile}
                    name="resourceImage"
                    accept="image/*"
                    disabled={AuthService.getUserTypeAdmin() === "3"}
                    
                  />
             
              </div>
            </Form.Group>
            <div className="Image-perview-container">
              {this.props.option === "edit" &&
              this.state.formValues.equipmentImage !== null ? (
                <div className="image-preview"   onClick={this.handleAvatarClick}>
                  {this.state.formValues.resourceImage instanceof Blob ? (
                    <img
                      src={URL.createObjectURL(
                        this.state.formValues.resourceImage
                      )}
                      alt="Overlay"
                      className="preview-image"
                    
                    />
                  ) : (
                    <img
                      src={`${API_URL}auth/assets/${
                        this.state.formValues.equipmentImage
                      }`}
                      alt="Preview"
                      className="preview-image"
                    />
                  )}
                  {/* <div className="close-icon" onClick={this.handleClearImage}>
                    <FontAwesomeIcon
                      icon={faTrash}
                      style={{ color: "rgb(138, 188, 73)" }}
                    />
                  </div> */}
                </div>
              ) : (
                <div className="image-preview" onClick={this.handleAvatarClick}>
                  {this.state.formValues.resourceImage instanceof Blob && (
                    <>
                      <img
                        src={URL.createObjectURL(
                          this.state.formValues.resourceImage
                        )}
                        alt="Preview"
                        className="preview-image"
                      />

                      {/* <div
                        className="close-icon"
                        onClick={this.handleClearImage}
                      >
                        <FontAwesomeIcon
                          icon={faTrash}
                          style={{ color: "rgb(138, 188, 73)" }}
                        />
                      </div> */}
                    </>
                  )}
                </div>
              )}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.props.handleClose}>
              Cancel
            </Button>
            <Button variant="success" type="button" onClick={this.saveForm}>
              {this.props.option === "edit"
                ? "Edit Equipment"
                : "Add Equipment"}
            </Button>
          </Modal.Footer>
        </Modal>

        {this.state.isModalOpen && (
         <EnlargeImage 
         onClose={this.handleModalClose} 
         imageUrl={
          (this.props.option === "edit"  && this.state.formValues.resourceImage )
            ? URL.createObjectURL(this.state.formValues.resourceImage)
            : (this.props.option === "edit" && this.state.formValues.resourceImage !== null)
              ? `${API_URL}auth/assets/${this.state.formValues.equipmentImage}`
              : URL.createObjectURL(this.state.formValues.resourceImage)
        }
       />
          
        )}
      </>
    );
  }

  handleAvatarClick = () => {


  
      this.setState({
        isModalOpen: true,
        
      });
   
  
  };



  handleModalClose = () => {
    this.setState({ isModalOpen: false });
  }

  handlefile = (event) => {
    const file = event.target.files[0];
    console.log("file", file);
    let form = { ...this.state.formValues };
    form[event.target.name] = file;
    this.setState({
      formValues: form,
    });
  };

  OnHandleChange = (event) => {
    let form = { ...this.state.formValues };

    if (event.target.name === "equipmentYears") {
      // Remove non-numeric characters
      const numericValue = event.target.value.replace(/\D/g, "");

      console.log("numericValue", numericValue);

      const truncatedValue = numericValue.slice(0, 4);
      console.log("truncatedValue", truncatedValue);

      form[event.target.name] = truncatedValue;
    } else {
      form[event.target.name] = event.target.value;
    }

    // Check if the target name is equipmentTimeService
    if (event.target.name === "equipmentTimeService") {
      this.setState({
        formValues: form,
        colorChange: true, // Set colorChange to true when equipmentTimeService changes
      });
    } else {
      this.setState({
        formValues: form,
      });
    }
  };

  saveForm = () => {
    if (!this.state.formValues.equipmentName) {
      this.props.errorToast("Please Enter Equipment Name");
    } else if (!this.state.formValues.equipmentModel) {
      this.props.errorToast("Please Enter Equipment Model");
    } else if (!this.state.formValues.equipmentTimeService) {
      this.props.errorToast("Please Enter Time Service Interval");
    }else {
      let form = new FormData();

      // Append form values to FormData
      const keysToInclude = [
        "equipmentDescription",
        "equipmentModel",
        "equipmentName",
        "equipmentSN",
        "equipmentTimeService",
        "equipmentYears",
        "year_acquired",
        "filterParts",
        "notes",
        "oilType"
      ];

      // Append only the specified keys from formValues to FormData
      keysToInclude.forEach((key) => {
        form.append(key, this.state.formValues[key]);
      });

      form.append("group_id", parseInt(AuthService.getUserId()));

      if (this.state.formValues.resourceImage?.name) {
        form.append("resourceImage", this.state.formValues.resourceImage);
      }

      if (this.props.option === "edit") {
        form.append("equipmentId", this.props.editValue.equipmentId);

        EquipmentApi.editEquipment(form).then((response) => {
          console.log(response, "equipment updated");
          if (response.data && response.data.message === "success") {
            this.props.handleClose();
            this.props.deleteandeditload();
            this.props.renderToast("Edit");
          }
        });
      } else {
        EquipmentApi.saveEquipment(form).then((response) => {
          if (response.data && response.data.message === "success") {
            this.props.handleClose();
            this.props.onLoad();
            this.props.renderToast("Create");
          }
        });
      }
    }
  };
}
export default CreateEquipment;
